import { v4 } from '@rotra-air-ocean/rotranext-shared-code';

export const TYPE_HINT: Record<v4.FieldInputType, string> = {
  text: 'Free text',
  email: 'Email address',
  number: 'Number',
  checkbox: 'Yes / no',
  select: 'One of a fixed set',
  array: 'A list of values or objects',
  object: 'A structured object with named properties',
};

export const FIELD_TYPE_LABEL: Record<v4.FieldInputType, string> = {
  text: 'Text',
  email: 'Email',
  number: 'Number',
  checkbox: 'Yes / no',
  select: 'Choice',
  array: 'List',
  object: 'Object',
};

export function createEmptyField(): v4.FieldSpec {
  return { name: '', label: '', inputType: 'text' };
}

export function createArrayItem(): v4.FieldSpec {
  return { name: 'item', label: 'Item', inputType: 'text' };
}

export function cloneField(field: v4.FieldSpec): v4.FieldSpec {
  return {
    ...field,
    options: field.options ? [...field.options] : undefined,
    items: field.items ? cloneField(field.items) : undefined,
    properties: field.properties?.map((property) => cloneField(property)),
  };
}

export function changeFieldType(
  field: v4.FieldSpec,
  inputType: v4.FieldInputType,
): v4.FieldSpec {
  const base = {
    name: field.name,
    label: field.label,
    optional: field.optional,
  };

  switch (inputType) {
    case 'select': {
      return {
        ...base,
        inputType,
        options: field.inputType === 'select' ? (field.options ?? []) : [],
      };
    }
    case 'array': {
      return {
        ...base,
        inputType,
        items:
          field.inputType === 'array' && field.items
            ? field.items
            : createArrayItem(),
      };
    }
    case 'object': {
      return {
        ...base,
        inputType,
        properties:
          field.inputType === 'object' ? (field.properties ?? []) : [],
      };
    }
    default: {
      return { ...base, inputType };
    }
  }
}

export function fieldSummary(field: v4.FieldSpec): string {
  const name = field.label.trim() || field.name.trim() || 'Untitled field';
  return `${name} · ${FIELD_TYPE_LABEL[field.inputType]}`;
}
